import { mutate } from 'swr';
import { CACHE_KEYS } from '@/constants/cache-keys';
import type { EntityKind } from '@/utils/detection-classes';

export function revalidateByCacheKeyPrefix(
    prefix: string,
    isExcluded?: (key: string) => boolean,
): Promise<unknown> {
    return mutate(
        (key) => {
            const stringKey =
                typeof key === 'string'
                    ? key
                    : Array.isArray(key) && typeof key[0] === 'string'
                      ? key[0]
                      : null;
            if (stringKey === null || !stringKey.startsWith(prefix))
                return false;
            return isExcluded ? !isExcluded(stringKey) : true;
        },
        undefined,
        { revalidate: true },
    );
}

const ENTITY_VIEW_CACHE_PREFIXES: Record<EntityKind, readonly string[]> = {
    person: ['person-', CACHE_KEYS.ALL_PERSONS],
    vehicle: [CACHE_KEYS.VEHICLE_PREFIX, CACHE_KEYS.ALL_VEHICLES],
};

export function revalidateEntityViews(
    entityKind: EntityKind,
    isExcluded?: (key: string) => boolean,
): Promise<unknown> {
    const prefixes = [
        CACHE_KEYS.EVENT_ENTITIES_PREFIX,
        ...ENTITY_VIEW_CACHE_PREFIXES[entityKind],
    ];
    return Promise.all(
        prefixes.map((prefix) =>
            revalidateByCacheKeyPrefix(prefix, isExcluded),
        ),
    );
}

export function revalidateIdentityViews(): Promise<unknown> {
    return Promise.all([
        revalidateEntityViews('person'),
        revalidateEntityViews('vehicle'),
    ]);
}
